<template>
  <ValidationObserver v-slot="{ invalid }">
    <el-form
      ref="resetForm"
      :model="resetForm"
      auto-complete="on"
      label-position="left"
    >
      <div class="my-9 text-base font-medium">
        パスワード再設定
      </div>
      <div class="please">
        <b>{{ getEmailReset }}</b> アカウントのパスワードを再設定しています
        <br />
        新しいパスワードを入力してください
      </div>

      <ValidationProvider
        name="パスワードの長さは"
        vid="password"
        :rules="{
          min: 8,
          max:20
        }"
        v-slot="{ errors }"
        class=""
      >
        <el-form-item prop="password">
          <span class="svg-container">
            <img src="@/assets/login/lock.png" alt="" />
          </span>
          <el-input
            v-model.trim="resetForm.password"
            name="password"
            auto-complete="on"
            placeholder="パスワード"
            type="password"
            @keyup.enter.native="handleResetPass"
          />
        </el-form-item>
        <span class="text-red-500">{{ errors[0] }}</span>
      </ValidationProvider>

      <ValidationProvider
        name="password_cofirm"
        :rules="{ confirmed: 'password' }"
        v-slot="{ errors }"
        class=""
      >
        <el-form-item prop="password_cofirm">
          <span class="svg-container">
            <img src="@/assets/login/lock.png" alt="" />
          </span>
          <el-input
            v-model.trim="resetForm.password_cofirm"
            name="password_cofirm"
            auto-complete="on"
            placeholder="パスワード確認"
            type="password"
            @keyup.enter.native="handleResetPass"
          />
        </el-form-item>
        <span class="text-red-500">{{ errors[0] }}</span>
      </ValidationProvider>

      <el-button
        class="mt-6"
        :loading="loading"
        style="width: 100%; color: black; background: #FDB92C;"
        @click.native.prevent="handleResetPass"
        :disabled="invalid || form_null"
      >
        <span class="font-normal text-base">設定</span>
      </el-button>
    </el-form>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: function() {
    return {
      resetForm: {
        password: "",
        password_cofirm: "",
      },
      loading: false,
    };
  },
  methods: {
    ...mapActions("auth", ["resetPassword"]),
    async handleResetPass() {
      const data = {
        token: this.$route.params.token,
        password: this.resetForm.password,
        re_password: this.resetForm.password_cofirm,
      };
      const res = await this.resetPassword(data);
      if (res.success) {
        this.$notify.success({
          title: "成功",
          message: `パスワードを正常に変更する`,
        });
        this.$router.push({ name: "login" });
      } else {
        this.$notify.error({
          title: "エラー",
          message: res.data.user_token,
        });
      }
    },
  },
  beforeMount() {
      this.$router.push({ name: "login" });
  },
  computed: {
    ...mapGetters("auth", ["getEmailReset"]),
    form_null() {
      return !this.resetForm.password_cofirm || !this.resetForm.password;
    },
  },
};
</script>

<style scoped>
.please {
  font-weight: 400;
  font-size: 14px;
  color: #00000073;
}
.form-item {
  margin-top: 16px;
}
</style>
